import React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {SmallCard} from '../../lib/small-card/small-card';
import {InContextAlert} from '@spaced-out/ui-design-system/lib/components/InContextAlert';
import {MeetingDateTimeInfo} from '../meeting-date-time-info/meeting-date-time-info';


export const RescheduleLimitReached = () => {
  const {t} = useLabelTranslation();

  return (
    <SmallCard
      title={t('Reschedule_Meeting', 'Reschedule Meeting')}
      icon="calendar"
    >
      <MeetingDateTimeInfo />
      <InContextAlert semantic="danger">{`${t(
        'This_meeting_cannot_be_rescheduled_since_the_limit_on_reschedule_attempts_has_been_exhausted',
        'This meeting cannot be rescheduled since the limit on reschedule attempts has been exhausted',
      )}.`}</InContextAlert>
    </SmallCard>
  );
};
